export const mutations = {
  setPhases(state, phases = []) {
    state.phases = phases;
  },
  setDisableNext(state, value) {
    state.disableNext = value;
  },
  setDisablePrevious(state, value) {
    state.disablePrevious = value;
  },
  setWaitForActionFlowCompletion(state, value) {
    state.waitForActionFlowCompletion = value;
  },
  setBulkProcessLoading(state, value) {
    state.bulkProcessLoading = value;
  },
  setActivePhaseAndStep(state, { value }) {
    state.activePhase = value?.phase || 0;
    state.activeStep = value?.step || 0;
  },
  setRecordDetails(state, { recordUUID, recordDetails }) {
    state.record = { ...state.record, [recordUUID]: recordDetails };
  },
  setStepCheckingInprogress(state, value) {
    state.stepCheckingInprogress = value;
  },
  setWizardDetailsMap(state, wizard) {
    state.wizardDetailsMap = { ...state.wizardDetailsMap, [wizard.UUID]: wizard };
  },
  setWizardOverviewMap(state, { phases, wizardUUID }) {
    state.wizardOverviewMap = { ...state.wizardOverviewMap, [wizardUUID]: phases };
  }
};
